/**
 * Labstep
 */

import { FieldType } from 'labstep-web/constants/form';
import type { FieldWithoutActionProps } from 'labstep-web/core/Form/Reusable/types';
import { Experiment } from 'labstep-web/models/experiment.model';
import { ProtocolTimer } from 'labstep-web/models/protocol-timer.model';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import rules from 'labstep-web/services/validation/rules';

export const protocolTimerFormFields: FieldWithoutActionProps[] = [
  {
    fieldType: FieldType.Text,
    name: 'name',
    validation: rules.protocol_timer.name,
    placeholder: 'Timer name',
    fieldLabel: 'Name',
    fieldExplainer: `Give your ${getHumanReadableEntityName(
      ProtocolTimer.entityName,
    )} a name so you can jump straight to it when running an ${getHumanReadableEntityName(
      Experiment.entityName,
    )}.`,
  },
  {
    fieldType: FieldType.Text,
    validation: rules.protocol_timer.hours,
    name: 'hours',
    placeholder: 'Hours',
    fieldLabel: 'Hours',
  },
  {
    fieldType: FieldType.Text,
    validation: rules.protocol_timer.minutes,
    name: 'minutes',
    placeholder: 'Minutes',
    fieldLabel: 'Minutes',
  },
  {
    fieldType: FieldType.Text,
    validation: rules.protocol_timer.seconds,
    name: 'seconds',
    placeholder: 'Seconds',
    fieldLabel: 'Seconds',
  },
];
